import request from '@/utils/request'
import URL from './urlTranslator'

// 获取计费限制信息
export function getBsLimitInfo() {
  return request({
    url: URL.sys.getBsLimitInfo,
    method: 'get'
  })
}
